<template>
  <WechatStoreMerchantBinding />
</template>

<script>
import WechatStoreMerchantBinding from "@/views/apps/weishop/merchants/setting/wechat/store_merchant_binding.vue";

export default {
  name: "RegionStoreWechatBindingAdapter",
  components: {
    WechatStoreMerchantBinding,
  },
};
</script>
